import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

/**
 * Placeholder slice — real auth state lives in AuthProvider / React context
 * because it's read-heavy and component-tree-scoped. This slice exists so
 * legacy components / feature modules can dispatch auxiliary auth events
 * (e.g. "role switch", "impersonation start") without prop-drilling.
 *
 * Wave 2 modules will extend this shape as needed.
 */
export interface AuthState {
  readonly lastLoginAt: string | null;
  readonly impersonating: string | null;
}

const initialState: AuthState = {
  lastLoginAt: null,
  impersonating: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginRecorded(state, action: PayloadAction<{ at: string }>) {
      state.lastLoginAt = action.payload.at;
    },
    impersonationStarted(state, action: PayloadAction<{ userId: string }>) {
      state.impersonating = action.payload.userId;
    },
    impersonationCleared(state) {
      state.impersonating = null;
    },
  },
});

export const { loginRecorded, impersonationStarted, impersonationCleared } = authSlice.actions;
export const authReducer = authSlice.reducer;
